/**
 * API client for trace dosing calculator endpoints.
 */
import { api } from './client';
import type {
  DosingBatch,
  DosingBatchListResponse,
  CreateBatchRequest,
  UpdateBatchRequest,
  SaveAsTemplateRequest,
  SaveAsTemplateResponse,
} from '@/types/traceDosing';

export async function getBatches(tankId: string, isTemplate: boolean = false): Promise<DosingBatch[]> {
  const response = await api.get<DosingBatchListResponse>(
    `/api/tanks/${tankId}/dosing/batches?is_template=${isTemplate}`
  );
  return response.batches;
}

export async function getTemplates(tankId: string): Promise<DosingBatch[]> {
  return getBatches(tankId, true);
}

export async function createBatch(tankId: string, batch: CreateBatchRequest): Promise<DosingBatch> {
  return api.post<DosingBatch>(`/api/tanks/${tankId}/dosing/batches`, batch);
}

export async function updateBatch(tankId: string, batchId: string, batch: UpdateBatchRequest): Promise<DosingBatch> {
  return api.put<DosingBatch>(`/api/tanks/${tankId}/dosing/batches/${batchId}`, batch);
}

export async function deleteBatch(tankId: string, batchId: string): Promise<void> {
  await api.delete(`/api/tanks/${tankId}/dosing/batches/${batchId}`);
}

export async function saveAsTemplate(tankId: string, batchId: string, request: SaveAsTemplateRequest): Promise<SaveAsTemplateResponse> {
  return api.post<SaveAsTemplateResponse>(
    `/api/tanks/${tankId}/dosing/batches/${batchId}/save-as-template`,
    request
  );
}

export async function deleteTemplate(tankId: string, batchId: string): Promise<void> {
  await api.delete(`/api/tanks/${tankId}/dosing/templates/${batchId}`);
}
